export interface StoredToken {
  token: string;
  expireAt: number; //Unix timestamp in seconds
}

const TOKEN_KEY = 'x-portal:session_token';

export const setToken = (token: string, expireAt: number): void => {
  const tokenData: StoredToken = {
    token,
    expireAt,
  };
  localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData));
};

export const getToken = (): string | null => {
  const tokenData = localStorage.getItem(TOKEN_KEY);
  if (!tokenData) return null;

  try {
    const { token, expireAt } = JSON.parse(tokenData) as StoredToken;
    if (Date.now() >= expireAt * 1000) {
      removeToken();
      return null;
    }

    return token;
  } catch (e) {
    console.error('Error parsing token from localStorage:', e);
    removeToken();
    return null;
  }
};

export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isTokenExpired = (): boolean => {
  const tokenData = localStorage.getItem(TOKEN_KEY);
  if (!tokenData) return true;

  try {
    const { expireAt } = JSON.parse(tokenData) as StoredToken;
    return Date.now() >= expireAt * 1000;
  } catch {
    return true;
  }
};
